<div class="flex flex-col gap-4">
  @if (isCurrentLocationLoading) {
    <app-loader/>
  }
  @if (!!displayCurrentLocation) {
    <app-address-auto-complete-result
      icon="location-crosshairs"
      [main]="myLocationText"
      (onResultClick)="onCurrentLocationClick.emit()"
      />
  }

  <!-- a11y: "Search on map" opens the map-picker dialog -> aria-haspopup="dialog". -->
  <app-address-auto-complete-result
    icon="map-location-dot"
    [main]="searchOnMapText"
    ariaHasPopup="dialog"
    (onResultClick)="onMapClick.emit()"
    />

    <div class="flex flex-col">
      <div class="flex flex-col">
        @for (stationData of favoriteStations?.lastSearches; track stationData) {
          <ul class="p-0 list-none">
            <li
              class="cursor-pointer"
              (click)="onLastSearchClick.emit(stationData)"
              >
              <app-favorite-station [station]="stationData" />
            </li>
          </ul>
        }
      </div>
    </div>
  </div>
